import { render, staticRenderFns } from "./h-select.vue?vue&type=template&id=b934bb48&scoped=true&lang=html"
import script from "./h-select.vue?vue&type=script&lang=js"
export * from "./h-select.vue?vue&type=script&lang=js"
import style0 from "./h-select.vue?vue&type=style&index=0&id=b934bb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b934bb48",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HLabel: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/forms/h-label.vue').default})
